<template>
  <div class="login-wrap">
    <div class="login-navBar">
      <div
        :class="curIndex == index ? 'navBar-item active' : 'navBar-item'"
        v-for="(item, index) in navBar"
        :key="index"
        @click="navClick(index)"
      >
        {{ item.title }}
      </div>
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="codeRuleForm"
      label-width="0"
      class="mobile-form login-form"
      @keyup.enter.native="submit"
    >
      <el-form-item label="" :prop="curInputProp" class="mobile">
        <el-input
          type="text"
          v-model.trim="ruleForm[curInputProp]"
          auto-complete="off"
          class="login-input pass-input"
          :placeholder="`请输入${
            curInputProp === 'mobile' ? '手机号' : '邮箱地址'
          }`"
        ></el-input>
      </el-form-item>
      <el-form-item label="" prop="vercode" class="sms_code">
        <el-input
          type="text"
          v-model.trim="ruleForm.vercode"
          auto-complete="off"
          class="login-input pass-input"
          placeholder="请输入验证码"
        ></el-input>
        <el-button
          @click="curInputProp === 'mobile' ? getSmsCode() : getEmailCode()"
          v-if="!count"
          class="login-btn"
          >获取验证码</el-button
        >
        <el-button v-else disabled class="login-btn getcode-btn"
          >{{ count }}秒后获取</el-button
        >
      </el-form-item>
      <el-form-tem class="submit-item">
        <el-button
          class="submit-btn"
          type="primary"
          @click="submit"
          :disabled="loginStatus"
          :loading="loginStatus"
        >
          登录
        </el-button>
      </el-form-tem>
    </el-form>
    <!-- 验证 -->
    <verification
      v-if="popInfo.show"
      :popInfo="popInfo"
      @sendSmsCode="getSmsCode"
    />
  </div>
</template>

<script>
import tokenFunc from '@/config/static/token'
import verification from "../Login/verifica.vue";
export default {
  props: {
    isDialog: {
      default: false,
      type: Boolean,
    },
  },
  components: { verification },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        let reg = /^1[0-9]{10}/;
        // let reg1 = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        }
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入邮箱"));
      } else {
        let reg1 =
          /^([A-Za-z0-9]*[-_\.]?[A-Za-z0-9]+)*[A-Za-z0-9\._-]@[a-zA-Z\d]+\.[a-zA-Z]{1,5}$/;
        // let reg1 = /^([a-zA-Z\d])(\w|\-|\.)+@[a-zA-Z\d]+\.[a-zA-Z]{1,5}$/
        if (!reg1.test(value)) {
          callback(new Error("请输入正确的邮箱"));
        }
        callback();
      }
    };
    return {
      url: "",
      ruleForm: {
        mobile: "",
        email: "",
        vercode: "", // 手机验证码
        sms_type: "login",
        type: 1,
      },
      count: null,
      timer: null,
      loginStatus: false,
      codeing: false,
      rules: {
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: validateMobile,
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: validateEmail, trigger: "blur" },
        ],
        vercode: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      navBar: [
        {
          title: "手机号",
          prop: "mobile",
        },
        {
          title: "邮箱",
          prop: "email",
        },
      ],
      curIndex: 0,
      curInputProp: "mobile",
      popInfo: {
        show: false,
      },
    };
  },
  created() {},
  methods: {
    async getEmailCode(codekey, imgcode) {
      if (!this.ruleForm.email) {
        this.$refs["codeRuleForm"].validateField("email");
        return false;
      }
      if (this.codeing) return;
      this.codeing = true;
      let mes_params = {
        type: 1,
      };
      mes_params[this.curInputProp] = this.ruleForm[this.curInputProp];
      if (codekey) {
        mes_params["codekey"] = codekey;
      }
      if (imgcode) {
        mes_params["imgcode"] = imgcode;
      }

      let operation = "";
      if (this.curInputProp == "mobile") {
        operation = "mes_send";
      } else if (this.curInputProp == "email") {
        operation = "email_code";
      }
      loginSdk
        .requestAction(operation, mes_params)
        .then((res) => {
          if (res.code == 0) {
            const TIME = 60;
            if (!this.timer) {
              this.count = TIME;
              this.timer = setInterval(() => {
                if (this.count > 1 && this.count <= TIME) {
                  this.count--;
                } else {
                  this.codeing = false;
                  clearInterval(this.timer);
                  this.timer = null;
                  this.count = null;
                }
              }, 1000);
            }
          } else {
            this.$message.error(res.msg);
            this.codeing = false;
          }
        })
        .catch((err) => {
          this.codeing = false;
        });
    },

    async getSmsCode(codekey, imgcode) {
      if (!this.ruleForm.mobile) {
        this.$refs["codeRuleForm"].validateField("mobile");
        return false;
      }
      if (this.codeing) return;
      this.codeing = true;

      let mes_params = {
        mobile: this.ruleForm.mobile,
        type: 1,
      };
      mes_params[this.curInputProp] = this.ruleForm[this.curInputProp];
      if (codekey) {
        mes_params["codekey"] = codekey;
      }
      if (imgcode) {
        mes_params["imgcode"] = imgcode;
      }
      let operation = "";
      if (this.curInputProp == "mobile") {
        operation = "mes_send";
      } else if (this.curInputProp == "email") {
        operation = "email_code";
      }
      loginSdk
        .requestAction(operation, mes_params)
        .then((res) => {
          if (res.code == 0) {
            this.popInfo.show = false;
            const TIME = 60;
            if (!this.timer) {
              this.count = TIME;
              this.timer = setInterval(() => {
                if (this.count > 1 && this.count <= TIME) {
                  this.count--;
                } else {
                  this.codeing = false;
                  clearInterval(this.timer);
                  this.timer = null;
                  this.count = null;
                }
              }, 1000);
            }
          } else {
            this.$message.error(res.msg);
            this.codeing = false;
            if (res.code == 10851) {
              this.popInfo.show = true;
            }
          }
        })
        .catch((err) => {
          this.codeing = false;
          this.getImage();
        });
    },
    submit() {
      var that = this;
      this.loginStatus = true;
      this.$refs["codeRuleForm"].validate((valid) => {
        if (valid) {
          let { vercode } = this.ruleForm;
          //手机验证码登录
          let loginParams = {
            vercode, //短信验证码
            register_type: 1,
          };
          loginParams[this.curInputProp] = this.ruleForm[this.curInputProp];
          let utmParams = localStorage.utmParams
            ? JSON.parse(localStorage.utmParams)
            : {};
          loginParams = Object.assign(loginParams, utmParams);
          let operation = "";
          if (this.curInputProp == "mobile") {
            operation = "mobilever_login";
          } else if (this.curInputProp == "email") {
            operation = "email_code_login";
          }
          loginSdk
            .requestAction(operation, loginParams)
            .then((res) => {
              let { code, error, msg, data } = res;
              if (code == 0) {
                this.loginStatus = false;
                that.afterLoginOperate(res.data);
              } else {
                this.loginStatus = false;
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {});
        } else {
          this.loginStatus = false;
        }
      });
    },
    navClick(ind) {
      this.loginStatus = false;
      this.timer = null;
      this.count = null;
      this.curIndex = ind;
      this.curInputProp = this.navBar[ind].prop;
      this.$refs["codeRuleForm"].resetFields();
    },
    afterLoginOperate (data) {
      tokenFunc.setToken(JSON.stringify(data.token))
      console.log(data, 'data.token')
      this.$store.dispatch("loginInfo").then((res) => {
        if (this.isDialog) {
          window.parent.postMessage({ type: "isLogin", val: data.token }, "*");
          return;
        }
        
        if (res) {
          const { search } = window.location
          const newUrl = decodeURIComponent(search).substring(6)
          if(newUrl && newUrl === 'enterprise-design-v1') {
            window.location.href = localStorage.getItem("enterprise-design-v1-url");
            return;
          } 
          
          let domain = res.current_team_domain;
          if (process.env.VUE_APP_RealmName && domain) {
            // 配置域名
            domain = domain.split(".")[0] + `.${process.env.VUE_APP_RealmName}`;
          }
          if (domain) {
            window.location.href = `https://${domain}`;
          } else {
            this.$router.push({ name: "Team", query: this.$route.query });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login-navBar {
  width: calc(100% - 100px);
  height: 30px;
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8e7ec;
  margin: 0 auto 16px;
  .navBar-item {
    color: #3b3946;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    margin-right: 32px;
    cursor: pointer;
    user-select: none;
    font-weight: 500;
  }
  .active {
    color: #5a2df5;
    position: relative;
    &::after {
      content: "";
      width: 100%;
      height: 2px;
      display: block;
      position: absolute;
      left: 0;
      bottom: -10px;
      background-color: #5a2df5;
    }
  }
}
</style>
